export const environment = {
  production: false,
  hmr: false,
  apiUrl:"https://feed.ths-true.com/api",
  baseUrl:"https://feed.ths-true.com/api",
  imagePath:"https://feed.ths-true.com/uploads",
  ssoBaseUrl:"https://feed.ths-true.com/api",



  // apiUrl:"http://localhost:6200/api",
  // baseUrl:"http://localhost:6200/api",
  // imagePath:"http://localhost:6200/uploads",
  // ssoBaseUrl:"http://localhost:6200/api",
  

  // apiUrl:"http://localhost:4000/api",
  // baseUrl:"http://localhost:4000/api",
  // imagePath:"http://localhost:4000/uploads",
  // ssoBaseUrl:"http://localhost:4000/api",
  
  sysName:"AI DETECTION MONITOR",
  sysVersion:"1.0",
  client_id:"korn-client",
  client_secret:"20bd501c-7276-4c1f-a687-b08d8779174e",
  regis_secret:"dm1zbG9jYWw6UEBzc3cwcmQ=",
  siteKeyCapCha:"6LdAW6olAAAAAP8C0yYpyTL18hrwZTv0U_mdjR0d",
  //googleMapKey:"AIzaSyAlQCXgab7H0o63Psf0tK69Srpoxpl_snM",
  googleMapKey:"AIzaSyDXTRyTxgpqDLMPpfLKzhvA5o9LMA0vkC8",
  realm_id:"korntracking",
  grant_type:"password"
};
